import { PublicClientApplication, SilentRequest } from "@azure/msal-browser";
import { AccountInfo, InteractionRequiredAuthError } from "@azure/msal-common";
import axios, { AxiosInstance } from "axios";
import { msalClientApplication } from "../..";

const msalRestClient: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_REST_BASEURL,
    headers: {
        "Content-Type": "application/json"
    }
})

const apiScope: string = "api://UnitCostsAPI/access_as_user";

/* Adds a interceptor for each request made with
 * previous created axiosInstance.
 */
msalRestClient.interceptors.request.use(
    async (config) => {

        const instance: PublicClientApplication = msalClientApplication;
        const accounts: AccountInfo[] = instance.getAllAccounts();

        if (accounts.length === 0) {
            /* No active account could be found within the current webcontext api 
             * User has to provide an account to login -- Interaction is needed 
             */

            try
            {
                let response = await instance.acquireTokenPopup({ scopes: [apiScope] });
                instance.setActiveAccount(response.account);

                /* Adds the valid JWT Bearer to the request header */
                config.headers["Authorization"] = "Bearer " + response.accessToken;
            }
            catch (error)
            {
                /* Handle unknown error -- Pass on error */
                return Promise.reject(error);
            }   
        }
        else {

            /* One or multiple accounts found | Try to login the user silently */

            let requestDetails: SilentRequest = accounts.length === 1 ? { scopes: [apiScope], account: accounts[0] } : { scopes: [apiScope], prompt: "select_account" };

            try
            {
                let silentResponse = await instance.acquireTokenSilent(requestDetails);
                instance.setActiveAccount(silentResponse.account);

                /* Add the valid JWT Bearer to the request header */
                config.headers["Authorization"] = "Bearer " + silentResponse.accessToken;
            }
            catch (silentError)
            {
                if (silentError instanceof InteractionRequiredAuthError) {

                    try
                    {
                        let interactiveResponse = await instance.acquireTokenPopup(requestDetails);
                        instance.setActiveAccount(interactiveResponse.account);

                        /* Add the valid JWT Bearer to the request header */
                        config.headers["Authorization"] = "Bearer " + interactiveResponse.accessToken;
                    }
                    catch (interactiveError)
                    {
                        /* Pass on error */
                        return Promise.reject(interactiveError);
                    }
                }
                else
                {
                    /* Pass on unknown error */
                    return Promise.reject(silentError);
                }
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error); /* Pass on error */
    }
);

export default msalRestClient;